import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './AfdelingenBeheer.css';
import api from '../services/api';

const digestInp = { background: '#fff', border: '1px solid #d1d5db', color: '#111827', borderRadius: 8, padding: '7px 10px', fontSize: 13 };

function DigestRij({ rij, afdelingen, busy, onOpslaan, onAnnuleren, onVerwijder, isNieuw }) {
  const [lokaal, setLokaal] = useState(rij);
  useEffect(() => { setLokaal(rij); }, [rij.id]);
  const toggleAfd = (id) => setLokaal(l => ({ ...l, afdeling_ids: l.afdeling_ids.includes(id) ? l.afdeling_ids.filter(x => x !== id) : [...l.afdeling_ids, id] }));
  return (
    <div style={{ border: '1px solid #e5e7eb', borderRadius: 10, padding: '12px 14px', marginBottom: 10, background: '#fafafa' }}>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 8 }}>
        <input style={{ ...digestInp, width: 220 }} placeholder="Omschrijving (bv. Werkvoorbereiders ochtend)" value={lokaal.naam} onChange={e => setLokaal({ ...lokaal, naam: e.target.value })} />
        <input style={{ ...digestInp, flex: '1 1 200px' }} placeholder="email@gvb.nl, tweede@gvb.nl, ..." value={lokaal.email} onChange={e => setLokaal({ ...lokaal, email: e.target.value })} />
        <select style={digestInp} value={lokaal.type} onChange={e => setLokaal({ ...lokaal, type: e.target.value })}>
          <option value="ochtend">🌅 ochtend</option>
          <option value="avond">🌙 avond</option>
          <option value="week">📅 wekelijks (ma)</option>
        </select>
        <input style={{ ...digestInp, width: 54 }} type="number" min="0" max="23" value={lokaal.verstuur_uur} onChange={e => setLokaal({ ...lokaal, verstuur_uur: e.target.value })} />
        <span style={{ fontSize: 12, color: '#94a3b8', alignSelf: 'center' }}>uur</span>
      </div>
      <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginBottom: 10 }}>
        {afdelingen.map(a => (
          <label key={a.id} style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 13 }}>
            <input type="checkbox" checked={lokaal.afdeling_ids.includes(a.id)} onChange={() => toggleAfd(a.id)} style={{ width: 15, height: 15, cursor: 'pointer' }} />
            <span style={{ color: '#111827' }}>{a.naam}</span>
          </label>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <div onClick={() => setLokaal({ ...lokaal, actief: !lokaal.actief })} style={{ cursor: 'pointer', fontSize: 11.5, fontWeight: 600, padding: '3px 12px', borderRadius: 20,
          background: lokaal.actief ? '#ecfdf5' : '#f3f4f6', color: lokaal.actief ? '#047857' : '#6b7280', border: '1px solid ' + (lokaal.actief ? '#a7f3d0' : '#d1d5db') }}>{lokaal.actief ? 'actief' : 'uit'}</div>
        <button onClick={() => onOpslaan(lokaal, isNieuw)} disabled={busy} className="btn-primary" style={{ padding: '6px 14px', fontSize: 12.5 }}>{busy ? '...' : 'Opslaan'}</button>
        {isNieuw
          ? <button onClick={onAnnuleren} style={{ background: '#f3f4f6', color: '#111827', border: '1px solid #d1d5db', padding: '6px 14px', borderRadius: 6, cursor: 'pointer', fontSize: 12.5 }}>Annuleren</button>
          : <button onClick={() => onVerwijder(rij.id)} style={{ background: '#7f1d1d', color: '#fff', border: 'none', padding: '6px 14px', borderRadius: 6, cursor: 'pointer', fontSize: 12.5 }}>Verwijderen</button>}
      </div>
    </div>
  );
}

function DigestSectie({ afdelingen }) {
  const [rijen, setRijen] = useState([]);
  const [nieuw, setNieuw] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get('/servicedesk/beheer/digest').then(r => setRijen(r.data.digest || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  const leeg = { naam: '', email: '', type: 'ochtend', verstuur_uur: 7, afdeling_ids: [], actief: true };
  const opslaan = async (rij, isNieuw) => {
    setBusy(true);
    try {
      if (isNieuw) await api.post('/servicedesk/beheer/digest', rij);
      else await api.put('/servicedesk/beheer/digest/' + rij.id, rij);
      setNieuw(null); await load();
    } catch (e) { alert(e?.response?.data?.message || 'Opslaan mislukt'); }
    setBusy(false);
  };
  const verwijder = async (id) => {
    if (!window.confirm('Digest verwijderen?')) return;
    try { await api.delete('/servicedesk/beheer/digest/' + id); await load(); } catch (e) {}
  };
  return (
    <div className="werkorders-section" style={{ marginTop: 24 }}>
      <h2>📬 Overdracht-digest</h2>
      <p style={{ fontSize: 13, color: '#94a3b8', margin: '4px 0 14px' }}>
        Eén gecombineerde ploegoverdracht-mail per ontvanger, met zelfgekozen afdelingen.
      </p>
      {rijen.map(r => <DigestRij key={r.id} rij={r} afdelingen={afdelingen} busy={busy} onOpslaan={opslaan} onVerwijder={verwijder} isNieuw={false} />)}
      {nieuw && <DigestRij rij={nieuw} afdelingen={afdelingen} busy={busy} onOpslaan={opslaan} onAnnuleren={() => setNieuw(null)} isNieuw={true} />}
      {!nieuw && <button onClick={() => setNieuw(leeg)} className="btn-primary" style={{ padding: '8px 16px' }}>+ Nieuwe digest</button>}
    </div>
  );
}

const PUSH_ROL_OPTIES = [
  { code: 'werkvoorbereider', label: 'Werkvoorbereider' },
  { code: 'uitvoerder', label: 'Uitvoerder' },
  { code: 'manager', label: 'Manager' },
  { code: 'hoofdbeheerder', label: 'Hoofdbeheerder' },
  { code: 'bedrijf_admin', label: 'Bedrijf-admin' },
];
// helper: comma-string <-> array
const rolHeeft = (str, code) => String(str || '').split(',').map(x=>x.trim()).filter(Boolean).includes(code);
const rolToggle = (str, code, aan) => {
  const arr = String(str || '').split(',').map(x=>x.trim()).filter(Boolean);
  const idx = arr.indexOf(code);
  if (aan && idx === -1) arr.push(code);
  if (!aan && idx !== -1) arr.splice(idx, 1);
  return arr.join(',');
};
const AfdelingenBeheer = () => {
  const navigate = useNavigate();
  const [afdelingen, setAfdelingen] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState({ naam: '', beschrijving: '', storing_email: '', storing_categorisatie_actief: true, storing_log_verplicht: true });
  const [portalInv, setPortalInv] = useState(null); // { afd, naam, email }
  const [portalRollen, setPortalRollen] = useState([]);
  const [portalMsg, setPortalMsg] = useState(null);
  const [appModulesAfd, setAppModulesAfd] = useState(null);
  const [appModules, setAppModules] = useState([]);
  const [appModulesLaden, setAppModulesLaden] = useState(false);
  const [portalBusy, setPortalBusy] = useState(false);
  const openPortalInvite = async (afd) => {
    setPortalMsg(null); setPortalInv({ afd, naam: '', email: '', portal_rol_id: '' });
    try {
      const r = await api.get('/portal-beheer/rollen');
      const rollen = r.data?.rollen || [];
      setPortalRollen(rollen);
      const kijker = rollen.find(x => x.naam === 'Kijker') || rollen[0];
      if (kijker) setPortalInv(prev => prev ? { ...prev, portal_rol_id: kijker.id } : prev);
    } catch (e) { setPortalRollen([]); }
  };
  const submitPortalInvite = async () => {
    if (!portalInv?.naam || !portalInv?.email) { setPortalMsg({ ok: false, t: 'Naam en e-mail zijn verplicht' }); return; }
    setPortalBusy(true); setPortalMsg(null);
    try {
      const r = await api.post('/portal-beheer/uitnodigen', { afdeling_id: portalInv.afd.id, naam: portalInv.naam.trim(), email: portalInv.email.trim(), portal_rol_id: portalInv.portal_rol_id || undefined });
      setPortalMsg({ ok: true, t: r.data?.message || 'Uitnodiging verstuurd' });
      setTimeout(() => setPortalInv(null), 1500);
    } catch (e) {
      setPortalMsg({ ok: false, t: e.response?.data?.message || 'Versturen mislukt' });
    } finally { setPortalBusy(false); }
  };
  const [cfgModal, setCfgModal] = useState(false);
  const [cfgObjCats, setCfgObjCats] = useState([]);
  const [cfgNieuweCat, setCfgNieuweCat] = useState('');
  const [cfgAfd, setCfgAfd] = useState(null);
  const [cfgRows, setCfgRows] = useState([]);
  const [cfgBusy, setCfgBusy] = useState(false);
  const [vsModal, setVsModal] = useState(false);
  const [vsAfd, setVsAfd] = useState(null);
  const [vsCat, setVsCat] = useState(true);
  const [vsLog, setVsLog] = useState(true);
  const [vsBusy, setVsBusy] = useState(false);
  const [dmModal, setDmModal] = useState(false);
  const [dmAfd, setDmAfd] = useState(null);
  const [dmCfg, setDmCfg] = useState({ actief: false, ontvangers: '', verzend_dag: 0, verzend_tijd: '20:00' });
  const [dmBusy, setDmBusy] = useState(false);
  const openDienstmail = async (afd) => {
    setDmAfd(afd);
    try {
      const r = await api.get('/afdelingen/' + afd.id + '/dienst-mail-config');
      const c = r.data.config || {};
      setDmCfg({ actief: !!c.actief, ontvangers: c.ontvangers || '', verzend_dag: c.verzend_dag ?? 0, verzend_tijd: (c.verzend_tijd || '20:00').slice(0,5) });
    } catch (e) {
      setDmCfg({ actief: false, ontvangers: '', verzend_dag: 0, verzend_tijd: '20:00' });
    }
    setDmModal(true);
  };
  const saveDienstmail = async () => {
    setDmBusy(true);
    try {
      await api.put('/afdelingen/' + dmAfd.id + '/dienst-mail-config', {
        actief: dmCfg.actief,
        ontvangers: dmCfg.ontvangers,
        verzend_dag: parseInt(dmCfg.verzend_dag, 10),
        verzend_tijd: dmCfg.verzend_tijd
      });
      setDmModal(false);
    } catch (e) {
      alert('Opslaan mislukt: ' + (e.response?.data?.message || e.message));
    } finally {
      setDmBusy(false);
    }
  };
  const [vsVelden, setVsVelden] = useState([]);

  useEffect(() => { loadAfdelingen(); }, []);

  const loadAfdelingen = async () => {
    try {
      const response = await api.get('/afdelingen?beheer=1');
      setAfdelingen(response.data.afdelingen || []);
      setLoading(false);
    } catch (error) {
      console.error('Fout bij laden afdelingen:', error);
      setLoading(false);
    }
  };

  const openNieuw = () => {
    setEditId(null);
    setFormData({ naam: '', beschrijving: '', storing_email: '' });
    setShowModal(true);
  };

  const MODULE_LABELS = {
    'inzetmiddelen:defect_push': 'Defect-melding push naar wvb',
    'monteurs_app:poortjes': 'Inzetmiddelen scannen',
    'monteurs_app:melding': 'Melding maken',
    'monteurs_app:planning': 'Planning',
    'monteurs_app:storing': 'Storingen',
    'monteurs_app:logboek': 'Logboek',
    'monteurs_app:locatie': 'Locaties',
    'monteurs_app:pasjes': 'Pasjes',
    'monteurs_app:projecten': 'Projecten',
    'monteurs_app:kennisbank': 'Kennisbank',
    'monteurs_app:documenten': 'Documenten',
    'monteurs_app:formulieren': 'Formulieren',
  };
  const openAppModules = async (afd) => {
    setAppModulesAfd(afd); setAppModulesLaden(true); setAppModules([]);
    try {
      const r = await api.get('/afdeling-modules/' + afd.id);
      setAppModules(r.data.modules || []);
    } catch (e) { setAppModules([]); }
    finally { setAppModulesLaden(false); }
  };
  const toggleModule = async (mod) => {
    const nieuw = !mod.enabled;
    setAppModules(rows => rows.map(x => x.recht_id === mod.recht_id ? { ...x, enabled: nieuw } : x));
    try {
      await api.post('/afdeling-modules/' + appModulesAfd.id, { recht_id: mod.recht_id, enabled: nieuw });
    } catch (e) {
      setAppModules(rows => rows.map(x => x.recht_id === mod.recht_id ? { ...x, enabled: !nieuw } : x));
      alert('Opslaan mislukt');
    }
  };

  const [gebruikersLijst, setGebruikersLijst] = useState([]);
  useEffect(() => {
    api.get('/gebruikers')
      .then(r => setGebruikersLijst(((r.data.gebruikers || r.data || [])).filter(g => g.actief !== false)))
      .catch(() => setGebruikersLijst([]));
  }, []);

  const openBewerken = (afd) => {
    setEditId(afd.id);
    setFormData({ naam: afd.naam || '', beschrijving: afd.beschrijving || '', storing_email: afd.storing_email || '', storing_categorisatie_actief: afd.storing_categorisatie_actief !== false, storing_log_verplicht: afd.storing_log_verplicht !== false, eigenaar_gebruiker_id: afd.eigenaar_gebruiker_id || '' });
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await api.put(`/afdelingen/${editId}`, formData);
      } else {
        await api.post('/afdelingen', formData);
      }
      setShowModal(false);
      setEditId(null);
      setFormData({ naam: '', beschrijving: '', storing_email: '', storing_categorisatie_actief: true, storing_log_verplicht: true });
      loadAfdelingen();
    } catch (error) {
      alert(error.response?.data?.message || 'Fout bij opslaan afdeling');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Afdeling verwijderen?')) return;
    try {
      await api.delete(`/afdelingen/${id}`);
      loadAfdelingen();
    } catch (error) {
      alert('Fout bij verwijderen afdeling');
    }
  };

  const CAT_LABELS = { onderhoud:'Onderhoud', reparatie:'Reparatie', inspectie:'Inspectie', storing:'Storing', storing_buitendienst:'Storing / Buiten dienst', weer_in_dienst:'Weer in dienst', vervangen:'Vervangen', overige:'Overige (vangnet)' };

  const [odModal, setOdModal] = useState(false);
  const [odAfd, setOdAfd] = useState(null);
  const [odRijen, setOdRijen] = useState([]);
  const [odBusy, setOdBusy] = useState(false);
  const openOverdracht = async (afd) => {
    setOdAfd(afd); setOdModal(true); setOdRijen([]);
    try {
      const r = await api.get('/servicedesk/beheer/overdracht');
      setOdRijen((r.data.overdracht || []).filter(x => x.afdeling_id === afd.id));
    } catch (e) { setOdRijen([]); }
  };
  const saveOverdracht = async () => {
    setOdBusy(true);
    try {
      for (const rij of odRijen) {
        await api.put('/servicedesk/beheer/overdracht/' + rij.id, {
          email_naar: rij.email_naar, verstuur_uur: rij.verstuur_uur, actief: rij.actief, naar_dienst: rij.naar_dienst
        });
      }
      setOdModal(false);
    } catch (e) { alert(e?.response?.data?.message || 'Opslaan mislukt'); }
    setOdBusy(false);
  };
  const odWijzig = (id, veld, waarde) => setOdRijen(rs => rs.map(r => r.id === id ? { ...r, [veld]: waarde } : r));

  const openMeldingen = async (afd) => {
    setCfgAfd(afd); setCfgModal(true); setCfgRows([]);
    try { const r = await api.get(`/afdeling-log-config/${afd.id}`); setCfgRows(r.data.config || []); setCfgObjCats(r.data.object_categorieen || []); setCfgNieuweCat(''); }
    catch (e) { alert('Fout bij laden meldingen-config'); }
  };
  const setCfgVeld = (categorie, veld, waarde) => {
    setCfgRows(rows => rows.map(r => r.categorie === categorie ? { ...r, [veld]: waarde } : r));
  };
  const saveMeldingen = async () => {
    setCfgBusy(true);
    try {
      for (const r of cfgRows) {
        await api.put(`/afdeling-log-config/${cfgAfd.id}/${r.categorie}`, { email: r.email || '', email_actief: !!r.email_actief, afdeling_push_actief: !!r.afdeling_push_actief, push_rollen: r.push_rollen || '' });
      }
      setCfgModal(false);
    } catch (e) { alert(e.response?.data?.message || 'Fout bij opslaan'); }
    finally { setCfgBusy(false); }
  };
  const addObjectcat = () => {
    if (!cfgNieuweCat) return;
    setCfgRows(rows => [...rows, { categorie: 'objectcat:' + cfgNieuweCat, label: cfgNieuweCat, email: '', email_actief: true, afdeling_push_actief: false, push_rollen: null }]);
    setCfgNieuweCat('');
  };
  const verwijderObjectcat = async (categorie) => {
    if (!window.confirm('Regel verwijderen?')) return;
    try {
      await api.delete(`/afdeling-log-config/${cfgAfd.id}/${encodeURIComponent(categorie)}`);
      setCfgRows(rows => rows.filter(r => r.categorie !== categorie));
    } catch (e) { alert(e.response?.data?.message || 'Verwijderen mislukt'); }
  };
  // --- Snelkeuzes (storing-presets per afdeling) ---
  const [skOpen, setSkOpen] = useState(false);
  const [skAfd, setSkAfd] = useState(null);
  const [skLijst, setSkLijst] = useState([]);
  const [skVelden, setSkVelden] = useState([]);
  const [skNaam, setSkNaam] = useState('');
  const [skKeuzes, setSkKeuzes] = useState({});
  const [skBusy, setSkBusy] = useState(false);
  const [vsCats, setVsCats] = useState([]);
  const [vsTab, setVsTab] = useState('Wissel');
  const [skCat, setSkCat] = useState('');
  const openSnelkeuzes = async (afd) => {
    setSkAfd(afd); setSkNaam(''); setSkKeuzes({}); setSkOpen(true);
    try {
      const [v, l] = await Promise.all([
        api.get('/servicedesk/beheer/velden'),
        api.get('/storing-snelkeuze/beheer', { params: { afdeling_id: afd.id } })
      ]);
      setSkVelden((v.data.velden || []).filter(x => x.actief && x.veld_type === 'dropdown'));
      setVsCats(v.data.object_categorieen || []);
      setSkLijst(l.data.snelkeuzes || []);
    } catch (e) { console.error(e); }
  };
  const saveSnelkeuze = async () => {
    if (!skNaam.trim()) { alert('Naam verplicht'); return; }
    setSkBusy(true);
    try {
      const opties = Object.entries(skKeuzes).filter(([, o]) => o).map(([veld_id, optie_id]) => ({ veld_id: parseInt(veld_id), optie_id: parseInt(optie_id) }));
      await api.post('/storing-snelkeuze', { afdeling_id: skAfd.id, naam: skNaam.trim(), opties, objectcategorie: skCat || null });
      setSkNaam(''); setSkKeuzes({});
      const l = await api.get('/storing-snelkeuze/beheer', { params: { afdeling_id: skAfd.id } });
      setSkLijst(l.data.snelkeuzes || []);
    } catch (e) { alert('Fout bij opslaan'); }
    setSkBusy(false);
  };
  const toggleSnelkeuze = async (sk) => {
    try {
      await api.put(`/storing-snelkeuze/${sk.id}`, { actief: !sk.actief });
      const l = await api.get('/storing-snelkeuze/beheer', { params: { afdeling_id: skAfd.id } });
      setSkLijst(l.data.snelkeuzes || []);
    } catch (e) { alert('Fout'); }
  };

  const wijzigSkCategorie = async (sk, cat) => {
    try {
      await api.put(`/storing-snelkeuze/${sk.id}`, { objectcategorie: cat || null });
      const l = await api.get('/storing-snelkeuze/beheer', { params: { afdeling_id: skAfd.id } });
      setSkLijst(l.data.snelkeuzes || []);
    } catch (e) { alert('Fout bij wijzigen categorie'); }
  };
  const openVerslagschema = async (afd) => {
    setVsAfd(afd); setVsCat(afd.storing_categorisatie_actief !== false); setVsLog(afd.storing_log_verplicht !== false); setVsModal(true); setVsVelden([]);
    try { const r = await api.get('/servicedesk/beheer/velden'); setVsVelden(r.data.velden || []); setVsCats(r.data.object_categorieen || []); } catch (e) {}
  };
  const vsSetVeld = (i, patch) => setVsVelden(vs => vs.map((v, idx) => idx === i ? { ...v, ...patch } : v));
  const vsSetOptie = (i, j, patch) => setVsVelden(vs => vs.map((v, idx) => idx === i ? { ...v, opties: (v.opties||[]).map((o, oj) => oj === j ? { ...o, ...patch } : o) } : v));
  const vsAddVeld = () => setVsVelden(vs => [...vs, { label: 'Nieuw veld', veld_type: 'dropdown', verplicht: true, volgorde: vs.length, actief: true, opties: [] }]);
  const vsAddOptie = (i) => setVsVelden(vs => vs.map((v, idx) => idx === i ? { ...v, opties: [...(v.opties||[]), { waarde: '', vereist_specificatie: false, volgorde: (v.opties||[]).length, actief: true, objectcategorie: vsTab === 'Algemeen' ? null : vsTab }] } : v));
  const saveVerslagschema = async () => {
    setVsBusy(true);
    try {
      await api.put(`/afdelingen/${vsAfd.id}/storing-config`, { storing_categorisatie_actief: vsCat, storing_log_verplicht: vsLog });
      for (const v of vsVelden) {
        let veldId = v.id;
        if (!veldId) {
          const r = await api.post('/servicedesk/beheer/velden', { label: v.label, veld_type: v.veld_type, verplicht: v.verplicht, volgorde: v.volgorde, sap_catalogus: v.sap_catalogus, categorie: v.categorie, subcategorie: v.subcategorie });
          veldId = r.data.id;
        } else {
          await api.put(`/servicedesk/beheer/velden/${veldId}`, { label: v.label, veld_type: v.veld_type, verplicht: v.verplicht, volgorde: v.volgorde, actief: v.actief });
        }
        for (const o of (v.opties || [])) {
          if (!o.id) {
            await api.post('/servicedesk/beheer/opties', { veld_id: veldId, waarde: o.waarde, vereist_specificatie: o.vereist_specificatie, volgorde: o.volgorde, objectcategorie: o.objectcategorie || null });
          } else {
            await api.put(`/servicedesk/beheer/opties/${o.id}`, { waarde: o.waarde, vereist_specificatie: o.vereist_specificatie, volgorde: o.volgorde, actief: o.actief, objectcategorie: o.objectcategorie || null });
          }
        }
      }
      setVsModal(false); loadAfdelingen();
    } catch (e) { alert(e.response?.data?.message || 'Fout bij opslaan'); }
    finally { setVsBusy(false); }
  };

  return (
    <>
      <div className="afdelingen-beheer">
        <div className="dashboard-container">
          <div className="dashboard-header">
            <h1>🏢 Afdelingen Beheer</h1>
          </div>

          <div style={{ padding: '15px 0', borderBottom: '1px solid #e5e7eb', marginBottom: '20px' }}>
            <button onClick={openNieuw} className="btn-primary">+ Nieuwe Afdeling</button>
          </div>

          <div className="werkorders-section">
            <h2>Afdelingen Overzicht</h2>
            {loading ? (
              <div className="loading">Laden...</div>
            ) : (
              <div className="werkorders-list">
                {afdelingen.map(afd => (
                  <div key={afd.id} className="werkorder-card">
                    <div className="werkorder-header">
                      <div className="werkorder-title-row">
                        <h3>🏢 {afd.naam}</h3>
                      </div>
                    </div>
                    {afd.beschrijving && (<p className="werkorder-beschrijving">{afd.beschrijving}</p>)}
                    <p style={{ fontSize: '13px', color: '#374151', margin: '6px 0 0' }}>
                      🔧 Categorisatie: {afd.storing_categorisatie_actief !== false ? 'aan' : 'uit'} · Log: {afd.storing_log_verplicht !== false ? 'verplicht' : 'optioneel'}
                    </p>
                    <div style={{ marginTop: '12px', display: 'flex', gap: '8px' }}>
                      <button onClick={() => openMeldingen(afd)} style={{ background: '#00B894', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer' }}>📋 Meldingen</button>
                      <button onClick={() => openVerslagschema(afd)} style={{ background: '#0ea5e9', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer' }}>🔧 Verslagschema</button>
                      <button onClick={() => openDienstmail(afd)} style={{ background: '#00D4AA', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer' }}>📅 Dienstmail</button>
                      <button onClick={() => openSnelkeuzes(afd)} style={{ background: '#f59e0b', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer' }}>⚡ Snelkeuzes</button>
                      <button onClick={() => openOverdracht(afd)} style={{ background: '#8b5cf6', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer' }}>🔄 Overdracht</button>
                      <button onClick={() => openPortalInvite(afd)} style={{ background: '#6366f1', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer' }}>📧 Klantenportaal</button>
                      <button onClick={() => openBewerken(afd)} style={{ background: '#3b82f6', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer' }}>✏️ Bewerken</button>
                      <button onClick={() => openAppModules(afd)} style={{ background: '#8b5cf6', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer' }}>App-modules</button>
                      <button onClick={() => handleDelete(afd.id)} style={{ background: '#ef4444', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer' }}>🗑️ Verwijderen</button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          <DigestSectie afdelingen={afdelingen} />
        </div>
      </div>

      {odModal && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center'}} onClick={() => setOdModal(false)}>
          <div style={{background:'#111827',border:'1px solid #374151',borderRadius:12,padding:'22px 24px',width:'min(560px, 92vw)'}} onClick={e => e.stopPropagation()}>
            <h2 style={{color:'#e2e8f0',fontSize:17,margin:'0 0 4px'}}>🔄 Ploegoverdracht — {odAfd?.naam}</h2>
            <p style={{color:'#94a3b8',fontSize:12.5,margin:'0 0 16px'}}>🌅 ochtend = samenvatting nachtdienst (22:00–06:00) · 🌙 avond = samenvatting dagdienst (06:00–22:00)</p>
            {odRijen.map(r => (
              <div key={r.id} style={{marginBottom:14}}>
                <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:6}}>
                  <span style={{color:'#e2e8f0',fontSize:13.5,fontWeight:700,width:86}}>{r.type === 'week' ? '📅 wekelijks' : r.type === 'avond' ? '🌙 avond' : '🌅 ochtend'}</span>
                  <label style={{fontSize:12,color:'#94a3b8'}}>om</label>
                  <input type="number" min="0" max="23" value={r.verstuur_uur}
                    onChange={e => odWijzig(r.id, 'verstuur_uur', e.target.value)}
                    style={{background:'#1f2937',border:'1px solid #374151',color:'#e2e8f0',borderRadius:8,padding:'6px 8px',fontSize:13,width:54}} />
                  <label style={{fontSize:12,color:'#94a3b8'}}>uur</label>
                  <div onClick={() => odWijzig(r.id, 'actief', !r.actief)} style={{cursor:'pointer',fontSize:11.5,fontWeight:600,padding:'3px 12px',borderRadius:20,marginLeft:'auto',
                    background: r.actief ? 'rgba(0,212,170,.15)' : '#1f2937', color: r.actief ? '#00D4AA' : '#94a3b8', border: `1px solid ${r.actief ? '#00D4AA' : '#374151'}`}}>{r.actief ? 'actief' : 'uit'}</div>
                </div>
                <input placeholder="email@gvb.nl, tweede@gvb.nl" value={r.email_naar}
                  onChange={e => odWijzig(r.id, 'email_naar', e.target.value)}
                  style={{background:'#1f2937',border:'1px solid #374151',color:'#e2e8f0',borderRadius:8,padding:'8px 10px',fontSize:13,width:'100%',boxSizing:'border-box'}} />
                <label style={{display:'flex',alignItems:'center',gap:8,marginTop:6,cursor:'pointer'}}>
                  <input type="checkbox" checked={!!r.naar_dienst} onChange={e => odWijzig(r.id, 'naar_dienst', e.target.checked)} style={{width:16,height:16,cursor:'pointer'}} />
                  <span style={{fontSize:12.5,color:'#94a3b8'}}>Ook naar de {r.type === 'avond' ? 'nachtdienst' : 'storingsdienst'} van dat moment (volgt de planning)</span>
                </label>
              </div>
            ))}
            {!odRijen.length && <p style={{color:'#94a3b8',fontSize:13}}>laden…</p>}
            <div style={{display:'flex',justifyContent:'flex-end',gap:10,marginTop:18}}>
              <button onClick={() => setOdModal(false)} style={{background:'#1f2937',color:'#e2e8f0',border:'1px solid #374151',padding:'8px 16px',borderRadius:6,cursor:'pointer'}}>Annuleren</button>
              <button onClick={saveOverdracht} disabled={odBusy} className="btn-primary" style={{padding:'8px 18px'}}>{odBusy ? '...' : 'Opslaan'}</button>
            </div>
          </div>
        </div>
      )}
      {showModal && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center'}} onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editId ? 'Afdeling Bewerken' : 'Nieuwe Afdeling'}</h2>
              <button onClick={() => setShowModal(false)} className="btn-close">×</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Naam *</label>
                <input type="text" value={formData.naam} onChange={(e) => setFormData({...formData, naam: e.target.value})} required />
              </div>
              <div className="form-group">
                <label>Beschrijving</label>
                <textarea value={formData.beschrijving} onChange={(e) => setFormData({...formData, beschrijving: e.target.value})} rows="3" />
              </div>
              {editId && gebruikersLijst.length > 0 && (
                <div className="form-group">
                  <label>Afdelingseigenaar</label>
                  <select value={formData.eigenaar_gebruiker_id || ''}
                    onChange={(e) => setFormData({...formData, eigenaar_gebruiker_id: e.target.value ? parseInt(e.target.value) : ''})}>
                    <option value="">— Geen eigenaar —</option>
                    {gebruikersLijst.map(g => (
                      <option key={g.id} value={g.id}>{`${g.voornaam || ''} ${g.achternaam || ''}`.trim()}</option>
                    ))}
                  </select>
                  <small style={{ color: '#6b7280' }}>Mag menu-teksten en (later) andere instellingen van deze afdeling beheren.</small>
                </div>
              )}
              <div className="modal-actions">
                <button type="button" onClick={() => setShowModal(false)} className="btn-secondary">Annuleren</button>
                <button type="submit" className="btn-primary">{editId ? 'Opslaan' : 'Afdeling Aanmaken'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
      {dmModal && (
        <div className="modal-overlay" onClick={() => setDmModal(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: 480 }}>
            <div className="modal-header">
              <h2>📅 Dienstrooster-mail — {dmAfd?.naam}</h2>
              <button onClick={() => setDmModal(false)} className="btn-close">×</button>
            </div>
            <div style={{ padding: '16px 20px' }}>
              <p style={{ fontSize: 13, color: '#6b7280', marginTop: 0 }}>Wekelijkse mail met wie er nacht- en storingsdienst heeft. Toont de lopende week (zo t/m za).</p>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14, cursor: 'pointer' }}>
                <input type="checkbox" checked={dmCfg.actief} onChange={e => setDmCfg({ ...dmCfg, actief: e.target.checked })} />
                <strong>Automatisch versturen</strong>
              </label>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Ontvangers (meerdere = komma)</label>
              <input type="text" value={dmCfg.ontvangers} onChange={e => setDmCfg({ ...dmCfg, ontvangers: e.target.value })}
                placeholder="techdesk@gvb.nl, dennis@gvb.nl"
                style={{ width: '100%', padding: 8, border: '1px solid #d1d5db', borderRadius: 6, marginBottom: 14, boxSizing: 'border-box' }} />
              <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
                <div style={{ flex: 1 }}>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Verzenddag</label>
                  <select value={dmCfg.verzend_dag} onChange={e => setDmCfg({ ...dmCfg, verzend_dag: e.target.value })}
                    style={{ width: '100%', padding: 8, border: '1px solid #d1d5db', borderRadius: 6 }}>
                    <option value={0}>Zondag</option>
                    <option value={1}>Maandag</option>
                    <option value={2}>Dinsdag</option>
                    <option value={3}>Woensdag</option>
                    <option value={4}>Donderdag</option>
                    <option value={5}>Vrijdag</option>
                    <option value={6}>Zaterdag</option>
                  </select>
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Tijd</label>
                  <input type="time" value={dmCfg.verzend_tijd} onChange={e => setDmCfg({ ...dmCfg, verzend_tijd: e.target.value })}
                    style={{ width: '100%', padding: 8, border: '1px solid #d1d5db', borderRadius: 6, boxSizing: 'border-box' }} />
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                <button type="button" onClick={() => setDmModal(false)} className="btn-secondary">Annuleren</button>
                <button type="button" onClick={saveDienstmail} className="btn-primary" disabled={dmBusy}>{dmBusy ? 'Opslaan...' : 'Opslaan'}</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {cfgModal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:16}} onClick={() => setCfgModal(false)}>
          <div className="modal-content" onClick={(e)=>e.stopPropagation()} style={{maxWidth:560,width:'100%',maxHeight:'85vh',overflowY:'auto'}}>
            <div className="modal-header">
              <h2>📋 Meldingen — {cfgAfd?.naam}</h2>
              <button onClick={() => setCfgModal(false)} className="btn-close">×</button>
            </div>
            <p style={{fontSize:13,color:'#6b7280',marginTop:0}}>Per categorie: e-mail naar een externe partij (Techdesk) en/of melden aan de hele afdeling.</p>
            {cfgRows.length === 0 ? (
              <div style={{padding:20,textAlign:'center',color:'#9ca3af'}}>Laden...</div>
            ) : cfgRows.filter(r => !String(r.categorie).startsWith('objectcat:')).map(r => (
              <div key={r.categorie} style={{border:'1px solid #e5e7eb',borderRadius:8,padding:12,marginBottom:10}}>
                <div style={{fontWeight:700,marginBottom:8,color:'#111827'}}>{r.label || CAT_LABELS[r.categorie] || r.categorie}</div>
                <input type="text" value={r.email || ''} onChange={(e)=>setCfgVeld(r.categorie,'email',e.target.value)} placeholder="techdesk@bedrijf.nl (meerdere = komma)" style={{width:'100%',padding:'8px 10px',border:'1px solid #d1d5db',borderRadius:6,boxSizing:'border-box',marginBottom:8}} />
                <div style={{fontSize:12,color:'#6b7280',marginBottom:4}}>E-mailadres ingevuld = mail wordt verstuurd</div>
                <label style={{display:'flex',alignItems:'center',gap:8,fontSize:14,color:'#374151',cursor:'pointer'}}>
                  <input type="checkbox" checked={!!r.afdeling_push_actief} onChange={(e)=>setCfgVeld(r.categorie,'afdeling_push_actief',e.target.checked)} /> Hele afdeling melden
                </label>
                <div style={{marginTop:8,paddingTop:8,borderTop:'1px solid #f1f5f9'}}>
                  <div style={{fontSize:13,color:'#6b7280',marginBottom:4}}>Push naar rol:</div>
                  <div style={{display:'flex',flexWrap:'wrap',gap:12}}>
                    {PUSH_ROL_OPTIES.map(opt => (
                      <label key={opt.code} style={{display:'flex',alignItems:'center',gap:6,fontSize:14,color:'#374151',cursor:'pointer'}}>
                        <input type="checkbox" checked={rolHeeft(r.push_rollen, opt.code)}
                          onChange={(e)=>setCfgVeld(r.categorie,'push_rollen', rolToggle(r.push_rollen, opt.code, e.target.checked))} />
                        {opt.label}
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            ))}
            <div style={{borderTop:'2px solid #e5e7eb',paddingTop:10,marginTop:4}}>
              <div style={{fontWeight:700,marginBottom:4,color:'#111827'}}>Objectcategorie-regels</div>
              <p style={{fontSize:12,color:'#6b7280',marginTop:0,marginBottom:8}}>Objecten met deze categorie mailen naar een eigen adres i.p.v. de standaard-lijst (bijv. DRIS → Techdesk + SPIE).</p>
              {cfgRows.filter(r => String(r.categorie).startsWith('objectcat:')).map(r => (
                <div key={r.categorie} style={{border:'1px solid #e5e7eb',borderRadius:8,padding:12,marginBottom:10}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
                    <div style={{fontWeight:700,color:'#111827'}}>{r.label || String(r.categorie).slice(10)}</div>
                    <button type="button" onClick={()=>verwijderObjectcat(r.categorie)} style={{background:'none',border:'none',color:'#dc2626',cursor:'pointer',fontSize:13}}>Verwijderen</button>
                  </div>
                  <input type="text" value={r.email || ''} onChange={(e)=>setCfgVeld(r.categorie,'email',e.target.value)} placeholder="techdesk@bedrijf.nl (meerdere = komma)" style={{width:'100%',padding:'8px 10px',border:'1px solid #d1d5db',borderRadius:6,boxSizing:'border-box',marginBottom:8}} />
                  <label style={{display:'flex',alignItems:'center',gap:8,fontSize:14,color:'#374151',cursor:'pointer'}}>
                    <input type="checkbox" checked={!!r.email_actief} onChange={(e)=>setCfgVeld(r.categorie,'email_actief',e.target.checked)} /> Actief
                  </label>
                </div>
              ))}
              {cfgObjCats.filter(c => !cfgRows.some(r => r.categorie === 'objectcat:' + c)).length > 0 && (
                <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:10}}>
                  <select value={cfgNieuweCat} onChange={(e)=>setCfgNieuweCat(e.target.value)} style={{flex:1,padding:'8px 10px',border:'1px solid #d1d5db',borderRadius:6}}>
                    <option value="">- kies objectcategorie -</option>
                    {cfgObjCats.filter(c => !cfgRows.some(r => r.categorie === 'objectcat:' + c)).map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                  <button type="button" onClick={addObjectcat} className="btn-secondary" disabled={!cfgNieuweCat}>+ Regel</button>
                </div>
              )}
            </div>
            <div className="modal-actions">
              <button type="button" onClick={() => setCfgModal(false)} className="btn-secondary">Annuleren</button>
              <button type="button" onClick={saveMeldingen} className="btn-primary" disabled={cfgBusy || cfgRows.length===0}>{cfgBusy ? 'Opslaan...' : 'Opslaan'}</button>
            </div>
          </div>
        </div>
      )}
      {vsModal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:16}} onClick={() => setVsModal(false)}>
          <div className="modal-content" onClick={(e)=>e.stopPropagation()} style={{maxWidth:560,width:'100%',maxHeight:'85vh',overflowY:'auto'}}>
            <div className="modal-header">
              <h2>🔧 Verslagschema — {vsAfd?.naam}</h2>
              <button onClick={() => setVsModal(false)} className="btn-close">×</button>
            </div>
            <p style={{fontSize:13,color:'#6b7280',marginTop:0}}>Bepaalt wat de monteur ziet bij het afmelden van een storing voor deze afdeling.</p>
            <label style={{display:'flex',alignItems:'center',gap:8,fontSize:14,color:'#374151',marginBottom:10,cursor:'pointer'}}>
              <input type="checkbox" checked={vsCat} onChange={(e)=>setVsCat(e.target.checked)} /> Categorisatie-velden tonen (objectdeel, schadebeeld, oorzaak, activiteit)
            </label>
            <label style={{display:'flex',alignItems:'center',gap:8,fontSize:14,color:'#374151',marginBottom:10,cursor:'pointer'}}>
              <input type="checkbox" checked={vsLog} onChange={(e)=>setVsLog(e.target.checked)} /> Log/opmerking verplicht bij afmelden
            </label>
            {vsCat && (
              <div style={{marginTop:6,marginBottom:10,borderTop:'1px solid #e5e7eb',paddingTop:10}}>
                <div style={{display:'flex',gap:6,flexWrap:'wrap',marginBottom:10}}>
                  {['Algemeen', ...vsCats].map(c => (
                    <button key={c} type="button" onClick={()=>setVsTab(c)} style={{
                      padding:'6px 14px', borderRadius:20, fontSize:13, fontWeight:600, cursor:'pointer',
                      border:'1px solid ' + (vsTab===c ? '#00D4AA' : '#d1d5db'),
                      background: vsTab===c ? '#00D4AA' : '#fff',
                      color: vsTab===c ? '#fff' : '#374151' }}>{c}</button>
                  ))}
                </div>
                <div style={{fontWeight:700,marginBottom:4,color:'#111827'}}>Velden</div>
                <p style={{fontSize:12,color:'#9ca3af',marginTop:0,marginBottom:8}}>Je bewerkt nu de opties voor: <strong>{vsTab}</strong>. Velden zelf gelden voor het hele bedrijf.</p>
                {vsVelden.map((v, i) => (
                  <div key={v.id || ('n'+i)} style={{border:'1px solid #e5e7eb',borderRadius:8,padding:10,marginBottom:10,opacity:v.actief===false?0.5:1}}>
                    <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:6}}>
                      <input value={v.label||''} onChange={e=>vsSetVeld(i,{label:e.target.value})} placeholder="Label" style={{flex:1,padding:'6px 8px',border:'1px solid #d1d5db',borderRadius:6}} />
                      <select value={v.veld_type||'dropdown'} onChange={e=>vsSetVeld(i,{veld_type:e.target.value})} style={{padding:'6px 8px',border:'1px solid #d1d5db',borderRadius:6}}>
                        <option value="dropdown">dropdown</option>
                        <option value="tekst">tekst</option>
                      </select>
                      <input type="number" value={v.volgorde||0} onChange={e=>vsSetVeld(i,{volgorde:parseInt(e.target.value,10)||0})} title="Volgorde" style={{width:60,padding:'6px 8px',border:'1px solid #d1d5db',borderRadius:6}} />
                    </div>
                    <div style={{display:'flex',gap:16,fontSize:13,color:'#374151',marginBottom:6}}>
                      <label style={{display:'flex',alignItems:'center',gap:6,cursor:'pointer'}}><input type="checkbox" checked={v.verplicht!==false} onChange={e=>vsSetVeld(i,{verplicht:e.target.checked})} /> Verplicht</label>
                      <label style={{display:'flex',alignItems:'center',gap:6,cursor:'pointer'}}><input type="checkbox" checked={v.actief!==false} onChange={e=>vsSetVeld(i,{actief:e.target.checked})} /> Actief</label>
                    </div>
                    {v.veld_type!=='tekst' && (
                      <div style={{paddingLeft:10,borderLeft:'2px solid #e5e7eb'}}>
                        {(v.opties||[]).map((o, j) => ({o, j})).filter(({o}) => vsTab === 'Algemeen' ? !o.objectcategorie : o.objectcategorie === vsTab).map(({o, j}) => (
                          <div key={o.id || ('n'+j)} style={{display:'flex',gap:6,alignItems:'center',marginBottom:4,opacity:o.actief===false?0.5:1}}>
                            <input value={o.waarde||''} onChange={e=>vsSetOptie(i,j,{waarde:e.target.value})} placeholder="Optie" style={{flex:1,padding:'4px 6px',border:'1px solid #d1d5db',borderRadius:6}} />
                            <label style={{display:'flex',alignItems:'center',gap:4,fontSize:12,color:'#6b7280',cursor:'pointer'}} title="Specificatie vereist"><input type="checkbox" checked={!!o.vereist_specificatie} onChange={e=>vsSetOptie(i,j,{vereist_specificatie:e.target.checked})} /> spec</label>
                            <label style={{display:'flex',alignItems:'center',gap:4,fontSize:12,color:'#6b7280',cursor:'pointer'}}><input type="checkbox" checked={o.actief!==false} onChange={e=>vsSetOptie(i,j,{actief:e.target.checked})} /> aan</label>
                          </div>
                        ))}
                        <button type="button" onClick={()=>vsAddOptie(i)} style={{background:'none',border:'1px dashed #9ca3af',borderRadius:6,padding:'4px 8px',fontSize:12,cursor:'pointer',color:'#374151',marginTop:2}}>+ optie</button>
                      </div>
                    )}
                  </div>
                ))}
                <button type="button" onClick={vsAddVeld} style={{background:'#f3f4f6',border:'1px solid #d1d5db',borderRadius:6,padding:'6px 12px',fontSize:13,cursor:'pointer',color:'#111827'}}>+ nieuw veld</button>
              </div>
            )}
            <div className="modal-actions">
              <button type="button" onClick={() => setVsModal(false)} className="btn-secondary">Annuleren</button>
              <button type="button" onClick={saveVerslagschema} className="btn-primary" disabled={vsBusy}>{vsBusy ? 'Opslaan...' : 'Opslaan'}</button>
            </div>
          </div>
        </div>
      )}

        {skOpen && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => setSkOpen(false)}>
            <div style={{ background: 'white', borderRadius: '12px', padding: '24px', width: '560px', maxWidth: '95vw', maxHeight: '85vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
              <h2 style={{ marginTop: 0 }}>⚡ Snelkeuzes — {skAfd?.naam}</h2>
              <p style={{ fontSize: '13px', color: '#6b7280' }}>Presets die het verslagschema in één klik invullen bij het afmelden van een storing.</p>

              <div style={{ background: '#f9fafb', borderRadius: '8px', padding: '14px', marginBottom: '16px' }}>
                <label style={{ fontSize: '13px', fontWeight: 600, display: 'block', marginBottom: '4px' }}>Geldt voor objectcategorie</label>
                <select value={skCat} onChange={e => setSkCat(e.target.value)} style={{ width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '6px', marginBottom: '10px' }}>
                  <option value="">Algemeen (alle objecten)</option>
                  {vsCats.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
                <label style={{ fontSize: '13px', fontWeight: 600, display: 'block', marginBottom: '4px' }}>Naam snelkeuze</label>
                <input value={skNaam} onChange={e => setSkNaam(e.target.value)} placeholder="bv. FL EP05" style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '6px', boxSizing: 'border-box', marginBottom: '10px' }} />
                {skVelden.map(v => (
                  <div key={v.id} style={{ marginBottom: '8px' }}>
                    <label style={{ fontSize: '13px', fontWeight: 600, display: 'block', marginBottom: '2px' }}>{v.label}</label>
                    <select value={skKeuzes[v.id] || ''} onChange={e => setSkKeuzes({ ...skKeuzes, [v.id]: e.target.value })} style={{ width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '6px' }}>
                      <option value="">- niet voorinvullen -</option>
                      {(v.opties || []).filter(o => o.actief && (!o.objectcategorie || !skCat || o.objectcategorie === skCat)).map(o => (
                        <option key={o.id} value={o.id}>{o.waarde}{o.code ? ` (${o.code})` : ''}</option>
                      ))}
                    </select>
                  </div>
                ))}
                <button type="button" onClick={saveSnelkeuze} disabled={skBusy} style={{ background: '#10b981', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', marginTop: '6px' }}>{skBusy ? 'Opslaan...' : '+ Toevoegen'}</button>
              </div>

              <h3 style={{ fontSize: '14px', marginBottom: '8px' }}>Bestaande snelkeuzes ({skLijst.length})</h3>
              {skLijst.length === 0 && <p style={{ fontSize: '13px', color: '#9ca3af' }}>Nog geen snelkeuzes.</p>}
              {skLijst.map(sk => (
                <div key={sk.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 10px', background: sk.actief ? '#f0fdf4' : '#f3f4f6', borderRadius: '6px', marginBottom: '6px' }}>
                  <span style={{ fontWeight: 600, fontSize: '14px', textDecoration: sk.actief ? 'none' : 'line-through' }}>{sk.naam}<select value={sk.objectcategorie || ''} onClick={e => e.stopPropagation()} onChange={e => wijzigSkCategorie(sk, e.target.value)} style={{ marginLeft: 8, fontSize: 11, fontWeight: 600, background: '#e0f2fe', color: '#0369a1', border: 'none', borderRadius: 10, padding: '2px 8px', cursor: 'pointer' }}>
                    <option value="">Algemeen</option>
                    {vsCats.map(c => <option key={c} value={c}>{c}</option>)}
                  </select></span>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button type="button" onClick={() => toggleSnelkeuze(sk)} style={{ background: sk.actief ? '#f59e0b' : '#10b981', color: 'white', border: 'none', padding: '4px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>{sk.actief ? 'Uit' : 'Aan'}</button>
                  </div>
                </div>
              ))}
              <div style={{ textAlign: 'right', marginTop: '12px' }}>
                <button type="button" onClick={() => setSkOpen(false)} style={{ background: '#6b7280', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer' }}>Sluiten</button>
              </div>
            </div>
          </div>
        )}
  {portalInv && (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => setPortalInv(null)}>
      <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 440, maxWidth: '92%' }} onClick={(e) => e.stopPropagation()}>
        <h3 style={{ margin: '0 0 4px', color: '#1a202c' }}>📧 Klantenportaal uitnodigen</h3>
        <p style={{ margin: '0 0 16px', fontSize: 13, color: '#64748b' }}>Afdeling <strong>{portalInv.afd.naam}</strong> — deze persoon ziet alleen de orderstatus van deze afdeling.</p>
        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Naam</label>
        <input value={portalInv.naam} onChange={(e) => setPortalInv({ ...portalInv, naam: e.target.value })} placeholder="Bijv. Jan Jansen" style={{ width: '100%', padding: 10, border: '1px solid #cbd5e1', borderRadius: 6, marginBottom: 12, boxSizing: 'border-box' }} />
        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>E-mail</label>
        <input type="email" value={portalInv.email} onChange={(e) => setPortalInv({ ...portalInv, email: e.target.value })} placeholder="jan@voorbeeld.nl" style={{ width: '100%', padding: 10, border: '1px solid #cbd5e1', borderRadius: 6, marginBottom: 12, boxSizing: 'border-box' }} />
        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Rol</label>
        <select value={portalInv.portal_rol_id || ''} onChange={(e) => setPortalInv({ ...portalInv, portal_rol_id: e.target.value })} style={{ width: '100%', padding: 10, border: '1px solid #cbd5e1', borderRadius: 6, marginBottom: 4, boxSizing: 'border-box', background: '#fff' }}>
          {portalRollen.map(r => <option key={r.id} value={r.id}>{r.naam}</option>)}
        </select>
        <p style={{ margin: '0 0 12px', fontSize: 12, color: '#94a3b8' }}>Kijker = alleen bekijken · Melder = ook storingen melden · Beheerder = volledig beheer.</p>
        {portalMsg && <div style={{ fontSize: 13, color: portalMsg.ok ? '#059669' : '#dc2626', marginBottom: 12 }}>{portalMsg.t}</div>}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={() => setPortalInv(null)} style={{ padding: '8px 14px', border: '1px solid #cbd5e1', background: '#fff', borderRadius: 6, cursor: 'pointer' }}>Annuleren</button>
          <button onClick={submitPortalInvite} disabled={portalBusy} style={{ padding: '8px 16px', border: 'none', background: '#6366f1', color: '#fff', borderRadius: 6, cursor: portalBusy ? 'wait' : 'pointer', fontWeight: 600 }}>{portalBusy ? 'Versturen…' : 'Uitnodigen'}</button>
        </div>
      </div>
    </div>
  )}
      {appModulesAfd && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:16}} onClick={() => setAppModulesAfd(null)}>
          <div className="modal-content" onClick={(e)=>e.stopPropagation()} style={{maxWidth:480,width:'100%',maxHeight:'85vh',overflowY:'auto'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
              <h2 style={{margin:0}}>App-modules — {appModulesAfd.naam}</h2>
              <button onClick={() => setAppModulesAfd(null)} className="btn-close">×</button>
            </div>
            <p style={{color:'#6b7280',fontSize:13,marginTop:0}}>Zet per afdeling aan welke tegels/meldingen actief zijn.</p>
            {appModulesLaden ? <p>Laden...</p> : appModules.length === 0 ? <p>Geen instelbare modules.</p> : (
              <div style={{display:'flex',flexDirection:'column',gap:2}}>
                {appModules.map(mod => (
                  <label key={mod.recht_id} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'10px 12px',borderRadius:8,background:'#f9fafb',cursor:'pointer'}}>
                    <span style={{fontSize:14,color:'#374151'}}>{MODULE_LABELS[mod.code] || mod.naam || mod.code}</span>
                    <input type="checkbox" checked={!!mod.enabled} onChange={() => toggleModule(mod)} style={{width:18,height:18,cursor:'pointer'}} />
                  </label>
                ))}
              </div>
            )}

          </div>
        </div>
      )}
    </>
  );
};

export default AfdelingenBeheer;
